import { useState, useEffect, memo } from "react";
import { Loader2, X, Heart, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const URL = "https://mekanname.com"
//const URL = "https://localhost:3000"

const FavoriteMekanCard = memo(({ mekan, onRemove }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 shadow-xl border border-white/10 transition-all duration-300 hover:scale-[1.02] transform">
      <div className="flex justify-between items-start">
        <div className="flex-1">
          <h3 className="font-bold text-xl text-white mb-2">{mekan.ad}</h3>
          <p className="text-gray-400 text-sm">
            <span className="font-semibold">
              {mekan.il}, {mekan.ilce}
            </span>
          </p>
          <p className="mt-2 text-gray-300 text-sm max-h-24 overflow-hidden text-ellipsis">
            {mekan.bilgi}
          </p>
        </div>
        <button
          onClick={() => onRemove(mekan.id)}
          className="ml-4 p-2 rounded-full text-red-400 bg-red-400/10 hover:bg-red-400/20 transition-colors"
          aria-label="Favorilerden Kaldır"
        >
          <X size={20} />
        </button>
      </div>
      <div className="mt-5 text-center">
        <button onClick={() => navigate(`/mekan/${mekan.id}`)}
          className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-xl transition"
        >
          Detaylı Bilgi
        </button>
      </div>
    </div>
  );
});

export default function FavoritePlaces() {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userId, setUserId] = useState(null);

  // Token'dan userId alma
  const getUserIdFromToken = (token) => {
    if (!token) return null;
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.user_id;
    } catch (e) {
      console.error("Token çözümlenirken hata oluştu:", e);
      return null;
    }
  };

  // Component mount olduğunda userId'yi set et
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const user_id_from_token = getUserIdFromToken(token);
      setUserId(user_id_from_token);
    }
  }, []); // boş dependency array → sadece mount'ta çalışır

  // userId hazır olduğunda favori mekanları çek
  useEffect(() => {
    if (!userId) return; // userId yoksa fetch yapma
    const fetchFavorites = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${API_URL}/api/favorites/${userId}`);
        setFavorites(response.data);
      } catch (err) {
        console.error("Favori mekanları çekerken hata:", err);
        setError("Favori mekanlar yüklenirken bir sorun oluştu.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchFavorites();
  }, [userId]);

  // Favori mekanı kaldırma işlemi
  const handleRemoveFavorite = async (mekanId) => {
    try {
      await axios.delete(`${API_URL}/api/favorites/${userId}/${mekanId}`);
      setFavorites(favorites.filter((mekan) => mekan.id !== mekanId));
      console.log("Mekan favorilerden kaldırıldı!");
    } catch (err) {
      console.error("Favoriyi kaldırırken hata:", err);
      setError("Mekanı favorilerden kaldırırken bir sorun oluştu.");
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white p-6 md:p-12 font-sans flex flex-col items-center">
      <div className="w-full max-w-4xl">
        <button
          onClick={() => navigate(-1)}
          className="mb-8 inline-flex items-center gap-2 text-sm font-semibold text-gray-300 hover:text-blue-400 transition-colors duration-200"
        >
          <ArrowLeft className="h-5 w-5" />
          Listeye Geri Dön
        </button>
        
        <h1 className="text-5xl md:text-6xl font-extrabold mb-8 text-center text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-emerald-400">
          <Heart size={32} className="inline-block mr-2" /> Favori Mekanlarım
        </h1>

        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <Loader2 size={48} className="animate-spin text-emerald-400" />
          </div>
        ) : error ? (
          <div className="bg-red-900/50 text-red-300 p-4 rounded-lg text-center">
            <p>{error}</p>
          </div>
        ) : favorites.length === 0 ? (
          <div className="bg-gray-800 p-8 rounded-2xl text-center shadow-lg">
            <p className="text-xl text-gray-400">Henüz favori mekanınız yok.</p>
            <p className="mt-2 text-gray-500">
              Keşfetmeye başlayın ve beğendiğiniz mekanları favorilerinize
              ekleyin!
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {favorites.map((mekan) => (
              <FavoriteMekanCard
                key={mekan.id}
                mekan={mekan}
                onRemove={handleRemoveFavorite}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
